import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from './util/invalidateQuery';

const accountNoteExchange: UpdatesConfig['Mutation'] = {
  accountNoteCreate: (_: Data, __: Variables, cache: Cache) => invalidateQuery(
    ['accountNoteCreate', 'accountNotes'],
    cache,
  ),
  accountNoteUpdate: (_: Data, __: Variables, cache: Cache) => invalidateQuery(
    ['accountNoteUpdate', 'accountNotes'],
    cache,
  ),
};

export default accountNoteExchange;
